import { createRootRoute, Outlet } from "@tanstack/react-router"

import { NexusShell } from "@/components/Layout/NexusShell"

export const Route = createRootRoute({
  component: NexusRootLayout,
})

function NexusRootLayout() {
  return (
    <NexusShell>
      <Outlet />
    </NexusShell>
  )
}
